import { render, staticRenderFns } from "./FollowerTransfer.vue?vue&type=template&id=ded8fc48&scoped=true&"
import script from "./FollowerTransfer.vue?vue&type=script&lang=js&"
export * from "./FollowerTransfer.vue?vue&type=script&lang=js&"
import style0 from "./FollowerTransfer.vue?vue&type=style&index=0&id=ded8fc48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded8fc48",
  null
  
)

export default component.exports